var _style, _defs, _polygon, _defs2, _path, _path2, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFpaRevised0607(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1500 1500",
    style: {
      enableBackground: "new 0 0 1500 1500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_2_);fill:none;stroke:#000000;stroke-width:5.071;}\n\t.st1{clip-path:url(#SVGID_4_);}\n\t.st2{font-family:'LibreFranklin-Bold';}\n\t.st3{font-size:96.6022px;}\n\t.st4{letter-spacing:30;}\n\t.st5{letter-spacing:18;}\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 95.5,
    y: 223.1,
    width: 1306.6,
    height: 1053.7
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1165.8,1090.6 785.1,1090.6 785.1,820.6 729.9,820.6 729.9,1090.6 709.5,1090.6 709.5,950.6  654.3,950.6 654.3,1090.6 633.9,1090.6 633.9,909.7 578.7,909.7 578.7,1090.6 558.4,1090.6 558.4,985.1 503.2,985.1 503.2,1090.6  482.8,1090.6 482.8,883.4 427.6,883.4 427.6,1090.6 98,1090.6 98,1274 1165.8,1274  "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 98,
    y: 223.1,
    width: 1304.1,
    height: 1051
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M1019.9,652.2c-1.1-4.4-0.7-9.1,0-13.8c1.8-0.4,3.6-0.7,5.5-0.7h21.5c12-0.4,24-0.4,36-1.1 c24.7-1.8,48.7-8,70.5-20.4c22.2-12.4,38.5-30.2,50.5-52.7c9.1-16.7,14.5-34.9,18.2-53.5c4-21.1,5.8-42.2,5.5-63.6 c-0.4-34.2-5.5-67.6-18.2-99.6c-9.5-24.4-22.9-46.2-41.5-64.7c-23.3-22.9-50.9-37.1-83.3-41.1c-6.5-0.7-13.5-1.5-20-1.5 c-18.5-0.4-37.5,0-56,0c-2.2,0-4.4,0.4-6.5,0.4c-0.4,1.8-0.7,3.3-0.7,4.7v6.5v693.9c0,8.4,0.4,16.7,2.2,25.1 c3.6,18.5,13.5,32.4,29.5,42.2c9.1,5.8,19.3,9.5,29.8,12.4c13.5,3.6,27.6,6.2,41.5,7.6c16.7,1.5,33.5,2.9,50.2,4.4 c0.7,0,1.5,0.4,2.5,0.4c1.5,4,0.7,7.6,0.4,12c-1.8,0.4-3.3,0.7-4.7,0.7h-5.1H821.7c-2.9,0-6.2,0.4-9.5-0.7c-0.4-1.1-0.7-2.5-0.7-4 v-47.3v-13.5V235.8c0-3.6,0.4-7.3,0.4-10.9c1.8-0.4,2.9-1.1,4.4-1.1h7.3h280c23.6,0,47.3,1.1,70.9,3.6c32.4,3.6,64,9.5,94.6,20.4 c25.1,9.1,48.7,20.7,69.8,37.8c32.7,26.2,52.7,60,60.7,101.1c3.6,18.9,4.4,37.8,2.9,57.1c-1.5,20-4.7,40-10.9,58.9 c-16.7,50.2-48.7,87.6-94.9,113.5c-23.3,12.7-48,21.5-73.8,27.3c-22.2,5.1-44.7,8-67.6,9.1c-13.8,0.4-27.6,1.1-41.5,1.1H1029 C1025.4,652.9,1022.5,653.3,1019.9,652.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M99.1,236.2c-1.5-4.4-1.1-8.4-0.4-12c1.5-0.4,2.5-0.7,3.6-0.7h5.8h675c2.9,0,6.2-0.4,9.1,0.7 c1.5,2.5,1.1,5.1,1.1,7.3v50.9v74.5c0,2.5,0,5.1-0.4,7.6c-2.9,1.8-5.8,1.1-8.4,1.1c-2.5-1.8-2.5-4.7-3.3-7.3 c-4-11.6-7.6-23.3-12-34.5c-4.7-13.1-10.9-25.5-18.2-37.5c-9.5-14.9-21.5-26.9-37.5-34.9c-10.2-5.1-20.7-8.4-32-10.5 c-14.9-2.9-30.5-4-45.8-4h-232c-2.2,0-4.4,0.4-6.5,0.4c-0.4,1.5-1.1,2.9-1.5,4c-0.4,2.5,0,4.7,0,7.3v377.1c0,3.6-0.7,7.3,0.7,10.5 c2.5,1.5,5.1,1.1,7.6,1.1h89.8h53.8c7.3,0,14.2-0.4,21.5-2.5c13.5-3.6,24.4-10.9,33.1-21.8c6.9-8.7,12-18.2,16-28.7 c5.8-14.5,9.8-30.2,12.7-45.5c0.7-2.9,1.5-6.2,2.2-9.5c2.2,0,4.4-0.4,6.2-0.4c0.4,1.1,0.7,1.8,0.7,2.2v7.3v212v9.1 c-2.5,0-4.4,0.4-6.5,0.4c-1.5-3.3-1.8-6.9-2.5-10.2c-3.3-15.6-6.9-30.9-13.1-45.5c-3.3-8-7.3-15.6-12-22.9 c-11.6-16.7-27.6-26.5-48.4-28.4c-4.7-0.4-9.5-0.7-14.2-0.7H406.4c-2.9,0-6.2-0.4-9.5,0.7c-0.4,1.1-0.7,2.5-1.1,4 c-0.4,2.5,0,4.7,0,7.3v309.5v68.4c0,2.2-0.4,4.4-0.4,6.5c-1.5,0.4-2.5,0.7-4,1.1h-5.8H107.8c-2.9,0-6.2,0.4-9.1-1.1 c-1.5-3.6-1.1-7.6-0.4-11.6c1.1-0.4,2.2-0.7,3.3-0.7c8-0.7,16.4-0.7,24.4-1.5c16.4-1.5,32.4-3.3,48-8.4c4.7-1.5,9.5-3.3,13.8-5.5 c19.3-9.1,30.9-24.4,35.3-45.1c1.8-8,2.5-16,2.5-24.4v-4.4V326.7c0-9.5-0.7-19.3-2.5-28.4c-4.7-21.1-16.4-36.4-36-45.8 c-11.6-5.5-24.4-8.7-37.1-10.9c-15.3-2.5-30.9-3.6-46.5-4.4C102.8,236.5,101.3,236.5,99.1,236.2"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 221.7854 1220.9879)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    className: "st2 st3 st4"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 105.3,
    y: 0,
    className: "st2 st3 st4"
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    x: 209.5,
    y: 0,
    className: "st2 st3 st4"
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    x: 314.8,
    y: 0,
    className: "st2 st3 st5"
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    x: 393.9,
    y: 0,
    className: "st2 st3 st4"
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    x: 495.9,
    y: 0,
    className: "st2 st3 st4"
  }, "T"), /*#__PURE__*/React.createElement("tspan", {
    x: 592.5,
    y: 0,
    className: "st2 st3 st4"
  }, "IC"), /*#__PURE__*/React.createElement("tspan", {
    x: 754.7,
    y: 0,
    className: "st2 st3"
  }, "S"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFpaRevised0607);
export default __webpack_public_path__ + "static/media/FPA-revised-0607.e8d5e6eddcd9369228d29ba97b60a6fc.svg";
export { ForwardRef as ReactComponent };